import React, { Fragment } from 'react';

const LocatorResultDetails = ({ place, includeDistance = true }) => {
  let dealerType;
  if (place.dealerType) {
    dealerType = place.dealerType.includes(', ')
      ? place.dealerType.split(', ')
      : place.dealerType.split();
  }

  return (
    <Fragment>
      {includeDistance && place.distance >= 0 && (
        <span className="map__result-distance">{place.distance} Miles</span>
      )}
      <h3 className="map__result-title">{place.details.name}</h3>
      <address className="map__result-address">
        {place.details.formatted_address && (
          <span>{place.details.formatted_address}</span>
        )}
        {place.details.formatted_phone_number && (
          <Fragment>
            <br />
            <span>
              <a
                className="map__result-phone"
                href={`tel:${place.details.formatted_phone_number}`}
              >
                {place.details.formatted_phone_number}
              </a>
            </span>
          </Fragment>
        )}
        {place.details.opening_hours && (
          <Fragment>
            <br />
            <span>
              Hours:{' '}
              {
                place.details.opening_hours.weekday_text[
                  new Date().getDay() - 1
                ].split(': ')[1]
              }
            </span>
          </Fragment>
        )}
        {dealerType && (
          <ul className="map__result-dealer-types">
            {dealerType.map((type, i) => (
              <li key={i}>{type}</li>
            ))}
          </ul>
        )}
      </address>
    </Fragment>
  );
};

export default LocatorResultDetails;
